// extracted by mini-css-extract-plugin
export var amountPaidColumn = "_ix-6";
export var emphasizeQuantity = "_ix-3";
export var flatBottomCorners = "_ix-5";
export var productImage = "_ix-0";
export var quantityContainer = "_ix-2";
export var tooltip = "_ix-1";
export var wrapAndEllipsesOverflow = "_ix-4";